<div class="background">
  <div *ngIf="(loading$ | async) || loading" class="spinner">
    <mat-spinner></mat-spinner>
  </div>

  <div
    [hidden]="loading$ | async"
    style="background: #fffbff; overflow-x: hidden"
  >
    <div class="row justify-content-center">
      <div
        style="background: #fffbff; width: 100%; max-width: 100%; padding: 0"
      >
        <div
          class=""
          style="
            background: #5b43d9;
            width: 100%;
            border-bottom-left-radius: 40px;
            border-bottom-right-radius: 40px;
            margin-top: -1px;
          "
        >
          <header
            class="denounce-table-title"
            style="
              margin: 0 auto;
              max-width: 1300px;
              padding: 0;
              padding-top: 20px;
              padding-bottom: 15px;
            "
          >
            <h2 style="margin: 0 !important">
              {{ "UserManagementTitle" | translate }}
            </h2>
          </header>
        </div>
        <section
          class="section-filter"
          style="width: 100%; max-width: 1300px; margin: 0 auto"
        >
          <div class="filter-container card">
            <div
              [formGroup]="searchForm"
              (ngSubmit)="filterUser()"
              class="filter-bar d-flex flex-row align-items-center justify-content-start"
            >
              <label class="filter__label" for="search">
                <span
                  class="material-icons"
                  style="
                    padding-bottom: 3px;
                    margin-left: 10px;
                    cursor: pointer;
                  "
                >
                  <img src="assets/icons/search.svg" alt="" />
                </span>
                <input
                  (keyup.enter)="filterUser()"
                  id="search"
                  type="search"
                  class="form-control"
                  placeholder="Pesquisar..."
                  name="search"
                  required
                  formControlName="search"
                />
              </label>
              <button class="search-button" (click)="filterUser()">
                {{ "UserManagementSearch" | translate }}
              </button>
            </div>

            <button
              (click)="openNewUserModal()"
              class="btn btn-new custom-button btn-outline-success"
            >
              <span class="material-icons">add</span>
              <span class="d-none d-md-inline">
                {{ "UserManagementNewUser" | translate }}
              </span>
            </button>
          </div>
        </section>
        <div
          class="card card-table"
          style="width: 100%; height: auto; background: #fffbff"
        >
          <div style="max-width: 1300px; margin: 0 auto" class="table__wrapper">
            <table
              mat-table
              [dataSource]="dataSource"
              #table
              style="padding-left: 5%; padding-right: 5%"
            >
              <!-- ID Column -->
              <ng-container matColumnDef="name" style="width: 20%">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ "UserManagementTableName" | translate }}
                  </span>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div
                    style="
                      color: var(
                        --material-theme-sys-light-on-primary-container,
                        #180064
                      );
                      font-family: Roboto;
                      font-size: 16px;
                      font-style: normal;
                      font-weight: 500;
                      line-height: 24px; /* 150% */
                    "
                    class="d-flex align-items-center justify-content-center"
                  >
                    {{ element.name }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="email" style="width: 15%">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ "UserManagementTableEmail" | translate }}
                  </span>
                </th>
                <td
                  mat-cell
                  style="
                    color: var(
                      --material-theme-sys-light-on-primary-container,
                      #180064
                    );
                    font-family: Roboto;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                  "
                  *matCellDef="let element"
                >
                  {{ element.email }}
                </td>
              </ng-container>
              <!-- Organization Column -->
              <ng-container matColumnDef="organization" style="width: 15%">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ "UserManagementTableOrganization" | translate }}
                  </span>
                </th>
                <td
                  style="
                    color: var(
                      --material-theme-sys-light-on-primary-container,
                      #180064
                    );
                    font-family: Roboto;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                  "
                  mat-cell
                  *matCellDef="let element"
                >
                  {{ element.organization }}
                </td>
              </ng-container>
              <!-- Date Column -->
              <ng-container matColumnDef="function" style="width: 15%">
                <th mat-header-cell *matHeaderCellDef>
                  <span>
                    {{ "UserManagementTableRole" | translate }}
                  </span>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div
                    style="
                      display: inline-flex;
                      padding: 8px 16px;
                      justify-content: center;
                      align-items: center;
                      color: #180064;
                      font-family: Roboto;
                      font-size: 16px;
                      font-style: normal;
                      font-weight: 400;
                      line-height: 24px;
                      min-width: 100px;
                      border-radius: 9999px;
                      background-color: #e5deff;
                    "
                  >
                    {{ element.role }}
                  </div>
                </td>
              </ng-container>
              <!-- Status Column -->
              <ng-container matColumnDef="status" style="width: 18%">
                <th mat-header-cell *matHeaderCellDef>
                  {{ "UserManagementTableStatus" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="circle-status"></div>
                  {{ "UserManagementTableStatusOnline" | translate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div style="gap: 15px" class="d-flex align-items-center">
                    <button
                      id="{{ 'btn-edit-user-' + i }}"
                      (click)="editUser(element)"
                      mat-icon-button
                      aria-label="Edit Icon"
                    >
                      <img src="assets/icons/editWhite.svg" alt="" />
                    </button>
                    <button
                      id="{{ 'btn-delete-user-' + i }}"
                      mat-icon-button
                      (click)="deleteUser(element)"
                      aria-label="Settings Icon"
                    >
                      <img
                        src="assets/icons/trash.svg"
                        alt=""
                        style="transform: scale(1.3)"
                      />
                    </button>
                    <!-- <button mat-icon-button aria-label="Lock Icon">
                      <mat-icon>lock</mat-icon>
                    </button> TODO: validate this action-->
                  </div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                class="user-row"
                *matRowDef="let row; columns: displayedColumns"
              ></tr>
            </table>

            <mat-paginator
              [pageSizeOptions]="[5, 10, 15]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
